import { Controller } from "@hotwired/stimulus"

// An Options card's Help panel: sets the card's option boxes to the options
// it found (by link id), one it hasn't got typed in as a new one, for the
// card's Save to save.
export default class extends Controller {
  static values = { form: String }

  fill({ params: { fill } }) {
    Object.entries(fill).forEach(([id, option]) => {
      const select = document.querySelector(`select[name='versions[${id}]'][form='${this.formValue}']`)
      if (!select) return
      const known = [...select.options].some(o => o.value === option)
      select.value = known ? option : "__new__"
      const typed = select.closest("label").querySelector("[data-new-version]")
      if (!known && typed) typed.value = option
      select.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
